<template>
  <div>
    <b-row>
      <b-col
        v-if="isLoading"
        md="12"
      >
        <h1>VERİLER HESAPLANIYOR LÜTFEN BEKLEYİNİZ..</h1>
      </b-col>
      <b-col
        md="12"
        sm="12"
      >
        <b-card>

          <b-form

            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >
            <!-- Son Calculation Durumu -->
            <b-row class="mb-3">
              <b-col md="12">
                <b-card v-if="currentCalculationStatus" class="calculation-status-card">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 class="mb-1">Son Hesaplama Durumu</h6>
                      <p class="mb-1">
                        <strong>Durum:</strong> 
                        <span :class="getStatusClass(currentCalculationStatus.latest && currentCalculationStatus.latest.status)">
                          {{ getStatusText(currentCalculationStatus.latest && currentCalculationStatus.latest.status) }}
                        </span>
                      </p>
                      <p class="mb-1" v-if="currentCalculationStatus.latest">
                        <strong>Tarih:</strong> {{ formatDate(currentCalculationStatus.latest.created_at) }}
                      </p>
                    </div>
                    <div v-if="currentCalculationStatus.running" class="text-right">
                      <b-progress 
                        :value="currentCalculationStatus.running.progress_percentage" 
                        :max="100"
                        variant="success"
                        class="mb-1"
                      ></b-progress>
                      <small>{{ currentCalculationStatus.running.progress_percentage }}% tamamlandı</small>
                    </div>
                  </div>
                </b-card>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">

                <b-form-group
                  :label="$t('Başlangıç Ay/Yıl')"
                  label-for="target_year"
                >  <b-input-group>

                  <b-form-select
                    v-model="filterData.start_year"
                    :options="targetYears"
                  />
                  <b-input-group-append>
                    <b-form-select
                      v-model="filterData.start_month"
                      :options="targetMonts"
                      text-field="name"
                      value-field="number"
                    />
                  </b-input-group-append>
                </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  :label="$t('Bitiş Ay/Yıl')"
                  label-for="target_year"
                >  <b-input-group>

                  <b-form-select
                    v-model="filterData.end_year"
                    :options="targetYears"
                  />
                  <b-input-group-append>
                    <b-form-select
                      v-model="filterData.end_month"
                      :options="targetMonts"
                      text-field="name"
                      value-field="number"
                    />
                  </b-input-group-append>
                </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">  <!-- Satış Temsilcisi -->
                <b-form-group
                  v-if="usersData"
                  :label="$t('Satış Temsilcisi')"
                  label-for="user_id"
                >
                  <v-select
                    id="user_id"
                    v-model="filterData.seller_codes"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="usersData"
                    :reduce="val => val.value"
                    :clearable="false"
                    :close-on-select="false"
                    input-id="user_id"
                    multiple
                  />
                </b-form-group></b-col>
            </b-row>
            <div class="d-flex gap-2">
              <b-button
                v-if="!isLoading"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="recalculateData"
              >
                Yeniden Hesapla
              </b-button>
              
              <b-button
                v-if="!isLoading"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="info"
                @click="showCalculationHistory"
              >
                Calculation Geçmişi
              </b-button>

              <b-button
                v-if="!isLoading"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="secondary"
                @click="fetchData"
              >
                Filtrele
              </b-button>
            </div>
          </b-form>

        </b-card>

      </b-col>
      <b-col
        v-if="reportData"
        md="12"
      >
        <b-row>
          <b-col md="3">
            <statistic-card-vertical
              color="secondary"
              icon="FlagIcon"
              :statistic="$staticParams.formatCurrency(reportData.total_buy)+' '"
              statistic-title="Toplam Alış"
            />
          </b-col>
          <b-col md="3">
            <statistic-card-vertical
              color="secondary"
              icon="FlagIcon"
              :statistic="$staticParams.formatCurrency(reportData.total_sell)"
              statistic-title="Toplam Satış"
            />
          </b-col>
          <b-col md="3">
            <statistic-card-vertical
              color="secondary"
              icon="FlagIcon"
              :statistic="'%'+$staticParams.formatCurrency(reportData.earning)"
              statistic-title="Toplam Karlılık"
            />
          </b-col>
          <b-col
            v-if="reportData"
            md="12"
          >
            <monthly-earning-table :filter-options="filterOptions" />
          </b-col>
        </b-row>

        <b-row>
          <b-col
            v-if="reportData"
            md="12"
          >
            <sales-chart
              v-if="true==false"
              :filter-options="filterOptions"
            />
          </b-col>
          <b-col

            md="12"
          />

          <b-col md="6">
            <seller-sales-record-table
              :filter-options="filterOptions"
            />
          </b-col>
          <b-col md="6">
            <seller-sales-table
              :filter-options="filterOptions"
            />
          </b-col>
          <b-col md="6">
            <customer-sales-table
              :filter-options="filterOptions"
            />
          </b-col>
          <b-col md="6">
            <location-sales-table
              :filter-options="filterOptions"
            />
          </b-col>
          <b-col md="6">
            <category-sales-table
              :filter-options="filterOptions"
            />
          </b-col>

          <b-col md="12">
            <product-sales-table
              :filter-options="filterOptions"
            />
          </b-col>
          <b-col md="12">
            <product-buy-record-table
              :filter-options="filterOptions"
            />
          </b-col>
          <b-col md="12">
            <product-sales-record-table
              :filter-options="filterOptions"
            />
          </b-col>
        </b-row>
      </b-col>

    </b-row>

    <!-- Calculation Geçmişi Modal -->
    <b-modal
      id="calculation-history-modal"
      title="Calculation Geçmişi"
      size="lg"
      scrollable
    >
      <div v-if="calculationHistory.length > 0">
        <div 
          v-for="calculation in calculationHistory" 
          :key="calculation.id"
          class="calculation-item mb-3 p-3 border rounded"
        >
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <h6 class="mb-1">
                Hesaplama #{{ calculation.id }}
              </h6>
              <p class="mb-1">
                <strong>Dönem:</strong> {{ calculation.start_year }}-{{ calculation.start_month }} - {{ calculation.end_year }}-{{ calculation.end_month }}
              </p>
              <p class="mb-1">
                <strong>Durum:</strong> 
                <span :class="getStatusClass(calculation.status)">
                  {{ getStatusText(calculation.status) }}
                </span>
              </p>
              <p class="mb-1">
                <strong>Oluşturulma:</strong> {{ formatDate(calculation.created_at) }}
              </p>
              <p class="mb-1" v-if="calculation.started_at">
                <strong>Başlama:</strong> {{ formatDate(calculation.started_at) }}
              </p>
              <p class="mb-1" v-if="calculation.completed_at">
                <strong>Tamamlanma:</strong> {{ formatDate(calculation.completed_at) }}
              </p>
            </div>
            <div v-if="calculation.status === 'running'" class="text-right">
              <b-progress 
                :value="calculation.progress_percentage" 
                :max="100"
                variant="success"
                class="mb-1"
                style="width: 100px;"
              ></b-progress>
              <small>{{ calculation.progress_percentage }}%</small>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center py-4">
        <p class="text-muted">Henüz hesaplama geçmişi bulunmuyor.</p>
      </div>
    </b-modal>
  </div></template>

<script>
import {
  BCard, BRow, BCol, BButton, BForm, BFormGroup, BFormSelect, BInputGroup, BInputGroupAppend, BModal, BProgress,
} from 'bootstrap-vue'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
import customerSalesTable from './CustomerSalesTable.vue'
import sellerSalesTable from './SellerSalesTable.vue'
import locationSalesTable from './LocationSalesTable.vue'
import categorySalesTable from './CategorySalesTable.vue'
import productSalesTable from './ProductSalesTable.vue'
import salesChart from './SalesChart.vue'
import reportsStoreModule from '../reportsStoreModule'
import sellerSalesRecordTable from './SellerSalesRecordTable.vue'
import productSalesRecordTable from './ProductSalesRecordTable.vue'
import productBuyRecordTable from './ProductBuyRecordTable.vue'
import monthlyEarningTable from './MonthlyEarningTable.vue'

export default {
  components: {
    BCard,
    BRow,
    salesChart,
    sellerSalesRecordTable,
    BCol,
    productSalesRecordTable,
    monthlyEarningTable,
    customerSalesTable,
    productBuyRecordTable,
    BFormSelect,
    sellerSalesTable,
    categorySalesTable,
    locationSalesTable,
    StatisticCardVertical,
    productSalesTable,
    BButton,
    BForm,
    BFormGroup,
    vSelect,
    BInputGroup,
    BInputGroupAppend,
    BModal,
    BProgress,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isLoading: false,
      filterData: {
        seller_codes: [],
        start_year: 2015,
        start_month: 0,
        end_year: 2015,
        end_month: 0,
        random_chars: '',
        type: '',
      },
      reportData: null,
      currentCalculationStatus: null,
      calculationHistory: [],
    }
  },
  computed: {
    filterOptions() {
      return {
        start_year: this.filterData.start_year,
        start_month: this.filterData.start_month,
        end_year: this.filterData.end_year,
        end_month: this.filterData.end_month,
        seller_code: '',
        seller_codes: this.filterData.seller_codes,
        location: '',
        buyer_name: '',
        product_code: '',
        category: '',
        other_category: '',
        seller_name: '',
        product_name: '',
        random_chars: this.filterData.random_chars,

      }
    },
    targetMonts() {
      const arr = [{ number: 0, name: 'Tümü' }]
      this.$staticParams.monthNames.forEach(val => {
        arr.push(val)
      })
      return arr
    },

  },

  created() {
    const d = new Date()
    const thisYear = d.getFullYear()

    this.filterData.start_year = thisYear
    this.filterData.end_year = thisYear
    this.filterData.start_month = 11
    this.filterData.end_month = 11
    if (this.$route.query.month) {
      // eslint-disable-next-line radix
      this.filterData.target_month = parseInt(this.$route.query.month)
      // eslint-disable-next-line radix
      this.targetDetailMonth = parseInt(this.$route.query.month)
    }
    if (this.$route.query.year) {
      // eslint-disable-next-line radix
      this.filterData.start_year = parseInt(this.$route.query.year)
      this.targetDetailMonth = 0
    }
    if (this.$route.query.type) {
      if (this.$route.query.type === 'current') {
        this.targetDetailMonth = 13
      }
    } else {
      this.filterData.type = ''
    }
    this.fetchData()
    this.loadCurrentCalculationStatus() // Son calculation durumunu yükle
  },

  methods: {
    changeRandomChars() {
      this.filterData.random_chars = Math.random()
    },

    showSuccessMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarılı'), {
        title: this.$t('İşlem Başarılı'),
        variant: 'success',
        solid: false,
      })
    },
    showErrorMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarısız'), {
        title: this.$t('İşlem Başarısız'),
        variant: 'danger',
        solid: false,
      })
    },
    fetchData() {
      this.changeRandomChars()
      store
        .dispatch('app-reports/fetchCustomReports', this.filterData)
        .then(response => {
          this.reportData = response.data.data
        })
        .catch(() => {
        })
    },
    calculateData() {
      this.isLoading = true
      store
        .dispatch('app-reports/calculateReports', this.filterData)
        .then(() => {
          this.isLoading = false
          this.fetchData()
          this.showSuccessMessage()
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    recalculateData() {
      this.isLoading = true
      store
        .dispatch('app-reports/recalculateReports', this.filterData)
        .then((response) => {
          this.isLoading = false
          if (response.data.success) {
            this.fetchData()
            this.showSuccessMessage()
            this.loadCurrentCalculationStatus() // Durumu yenile
          } else {
            this.$bvToast.toast(response.data.message || 'Zaten devam eden bir hesaplama var', {
              title: 'Bilgi',
              variant: 'info',
              solid: false,
            })
          }
        })
        .catch((error) => {
          this.isLoading = false
          if (error.response && error.response.data && error.response.data.message) {
            this.$bvToast.toast(error.response.data.message, {
              title: 'Hata',
              variant: 'danger',
              solid: false,
            })
          } else {
            this.showErrorMessage()
          }
        })
    },
    loadCurrentCalculationStatus() {
      store
        .dispatch('app-reports/getCurrentCalculationStatus')
        .then((response) => {
          this.currentCalculationStatus = response.data.data
        })
        .catch(() => {
          // Hata durumunda sessizce geç
        })
    },
    showCalculationHistory() {
      store
        .dispatch('app-reports/getCalculationHistory')
        .then((response) => {
          this.calculationHistory = response.data.data
          this.$bvModal.show('calculation-history-modal')
        })
        .catch(() => {
          this.$bvToast.toast('Calculation geçmişi yüklenirken hata oluştu', {
            title: 'Hata',
            variant: 'danger',
            solid: false,
          })
        })
    },
    getStatusClass(status) {
      const classes = {
        'pending': 'text-warning',
        'running': 'text-info',
        'completed': 'text-success',
        'failed': 'text-danger'
      }
      return classes[status] || 'text-muted'
    },
    getStatusText(status) {
      const texts = {
        'pending': 'Bekliyor',
        'running': 'Çalışıyor',
        'completed': 'Tamamlandı',
        'failed': 'Başarısız'
      }
      return texts[status] || 'Bilinmiyor'
    },
    formatDate(dateString) {
      if (!dateString) return '-'
      return new Date(dateString).toLocaleString('tr-TR')
    },
  },
  setup() {
    const APP_STORE_MODULE_NAME = 'app-reports'

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, reportsStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })

    // eslint-disable-next-line no-unused-vars
    const targetsData = ref(null)
    const targetYear = ref(2015)
    const targetYearStart = ref(2015)
    const targetYears = ref([])
    const d = new Date()
    const thisYear = d.getFullYear()

    targetYear.value = thisYear
    const arrTarget = []
    // eslint-disable-next-line no-plusplus
    for (let i = targetYearStart.value; i <= thisYear + 1; i++) {
      arrTarget.push({ text: i, value: i })
    }
    targetYears.value = arrTarget

    const usersData = ref(null)
    store
      .dispatch('app/fetchReportUsers', {
        list_type: 'all',

      })
      .then(response => {
        const { data } = response.data
        const arr = []
        data.forEach(val => {
          arr.push({ label: `${val.seller_name} `, value: val.seller_code })
        })

        usersData.value = arr
      })
      .catch(() => {
      })

    return {

      // Filter
      avatarText,
      usersData,
      targetYears,
      // UI
      // Extra Filters
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.vgt-table {
    font-size: 13px;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}

.calculation-status-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px solid #dee2e6;
}

.calculation-item {
  background: #f8f9fa;
  transition: all 0.3s ease;
  
  &:hover {
    background: #e9ecef;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
}

.gap-2 {
  gap: 0.5rem;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
